import React, { FunctionComponent, memo } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useRemoveSelectedFeature } from '../../../../../../../../hooks/features/useRemoveSelectedFeature';
import IFeature from '../../../../../../../../model/IFeature';
import summaryStyles from '../../../../../summary/summarySection/SummaryStyles';
import { FeatureType } from '../../../../../../../../enum/FeatureType';
import SelectedFeaturePrice from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeaturePrice/SelectedFeaturePrice';
import ChangeSelectedOptionLink from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeatureAction/ChangeSelectedOptionLink';
import RemoveSelectedOptionLink from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeatureAction/RemoveSelectedOptionLink';
import { AddOnsTypes } from '../../../../../../../../enum/AddOnsTypes';
import IndicativeNumber from '../../../../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';
import Translation from '../../../../../../../../../gqlCommon/components/translation/Translation';
import SpecificationDisclaimer from '../../../../../../../../../gqlCommon/components/presentation/specificationDisclaimer/SpecificationDisclaimer';
import useScrollToSection from '../../../../../../../../hooks/navigation/useScrollToSection';
import FeatureColorPrice from '../../../../../features/featureColor/featureColorPrice/FeatureColorPrice';
import usePlatformConfig from '../../../../../../../../../common/react/usePlatformConfig';

export interface ISelectedOptionProps {
  sectionCode: string;
  feature: IFeature;
  sectionType?: string;
}

const SelectedOption: FunctionComponent<ISelectedOptionProps> = memo(({ sectionCode, feature, sectionType }) => {
  const styles = summaryStyles();
  const { scrollToSection, scrollToDisclaimer } = useScrollToSection();

  const {
    platformConfig: { showInteriorAndExteriorPrice },
  } = usePlatformConfig();

  const { removeSelectedFeature } = useRemoveSelectedFeature();

  return (
    <Box className={styles.selectedOptionContainer} data-test={`container:selected-option:${feature.code}`}>
      <Grid container={true} className={styles.selectedOptionTitlePrice}>
        <Typography variant="caption" className={styles.selectedOptionLabels}>
          {feature.name ?? feature.label}
          {showInteriorAndExteriorPrice && (
            <>
              {' '}
              <FeatureColorPrice price={feature.prices[0].money} />
            </>
          )}
          {feature.name === AddOnsTypes.GUARANTEED_COE && (
            <IndicativeNumber
              dataTest="guaranteed_coe"
              displayNumber={<Translation id="trans__configurator__indicative_numbers__option" />}
              onClick={scrollToDisclaimer}
            />
          )}
          {feature.attributes?.disclaimer && <SpecificationDisclaimer disclaimer={feature.attributes?.disclaimer} />}
        </Typography>
        <SelectedFeaturePrice feature={feature} />
      </Grid>
      {!!sectionType && sectionType === FeatureType.mutex1 ? (
        <ChangeSelectedOptionLink onClick={() => scrollToSection(sectionCode)} />
      ) : !!feature.categoryCode && !feature.attributes.isDefaultItem ? (
        <RemoveSelectedOptionLink onClick={() => removeSelectedFeature(feature.code)} optionCode={feature.code} />
      ) : null}
    </Box>
  );
});

export default SelectedOption;
